module.exports = __webpack_public_path__ + "img/c.9f53de31.jpg";